export default __webpack_public_path__ + "static/media/dibs-logo.c82480a1.svg";